module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_LT-2b03bceee8a867d25908095743e397ba.svg";